import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

class AccordionSection extends React.Component {
  state = {
    isOpen: false
  }

  toggleOpen = () => {
    this.setState((prev) => ({ isOpen: !prev.isOpen }));
  }

  handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.toggleOpen();
    }
  }

  render() {
    const { children, title, overflowContent } = this.props;
    const { isOpen } = this.state;

    const filterTitleEscaped = title.toLowerCase().replace(/ /g, '-');
    const panelId = `accordion-panel-${filterTitleEscaped}`;
    const buttonId = `${panelId}-button`;

    return (
      <div className={classNames(
        "filter-section",
        `cx-filters-${filterTitleEscaped}`,
        "accordion-section",
        `${filterTitleEscaped}`,
        { "overflow-content": overflowContent }
      )}>
        <div
          aria-controls={panelId}
          aria-expanded={isOpen}
          className="flex-row accordion-tab"
          role="button"
          id={buttonId}
          tabIndex={0}
          aria-label={title}
          onClick={this.toggleOpen}
          onKeyDown={this.handleKeyDown}
        >
          <p aria-level={3} className="accordion-title" role="heading" >{title}</p>
          <span
            aria-hidden="true"
            className={`bff-caret-down ${isOpen ? 'open' : ''} `}
          />
        </div>
        <div
          aria-labelledby={buttonId}
          className={`accordion-content ${isOpen ? 'open' : 'closed'}`}
          hidden={!isOpen}
          id={panelId}
          role="region"
        >
          {isOpen && children}
        </div>
      </div>
    );
  }
}

AccordionSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  overflowContent: PropTypes.bool
};

AccordionSection.defaultProps = {
  overflowContent: false
}

export default AccordionSection;
